export type TExperimentTab = "experiments" | "assignment" | "flags"
export const TABS: Array<{ id: TExperimentTab; label: string }> = [
  { id: "experiments", label: "Experiments" },
  { id: "assignment", label: "Assignment Lab" },
  { id: "flags", label: "Feature Flags" },
]

/** Normalize a URL search value to one of the supported Experiment Lab tabs. */
export const parseExperimentTab = (value: unknown): TExperimentTab =>
  typeof value === "string" && TABS.some((tab) => tab.id === value) ? (value as TExperimentTab) : "experiments"

/** Render nullable PostHog result values without conflating unavailable data with zero. */
export const formatExperimentResultValue = (value: number | null): string =>
  value === null ? "Unknown" : String(value)

/** Only apply an assignment to the browser when it targets the currently signed-in user. */
export const shouldApplyAssignmentToBrowser = (targetUserId: string, currentUserId: string | undefined): boolean =>
  targetUserId === currentUserId

/** Keep assignment mutations disabled until the exact user and experiment query has resolved. */
export const isExperimentAssignmentReady = (isSuccess: boolean): boolean => isSuccess
